import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import fetchApi from "../../services/fetch-data.service";
import { useEffect } from "react";
import { create } from "../../services/upload-files.service";

const ReportsWaterDataDetails = () => {

    const { state } = useLocation();
    const [reportData, setReportData] = useState()
    const [reportingperiod, setReportingPeriod] = useState()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const fetchReportData = async (id) => {
        try {
            setLoading(true)
            const response = await fetchApi(`reports/internal/GetSavedReport/${id}`);
            setReportData(JSON.parse(response.data.report_data));
            setLoading(false)
        } catch (error) {
            console.error('Error fetching report data:', error);
        }
    };

    useEffect(() => {
        if (state && state.id) {
            fetchReportData(state.id);

            const formatFromDate = new Date(state.formattedfromdate);
            const formatToDate = new Date(state.formattedtodate);

            // Get the month and year
            const frommonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatFromDate);
            const fromyear = formatFromDate.getFullYear();
            const tomonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatToDate);
            const toyear = formatToDate.getFullYear();

            // Output the result
            const formattedDate = `${frommonth} ${fromyear} - ${tomonth} ${toyear}`;
            setReportingPeriod(formattedDate);

        } else if (state && state.data && state.formData) {
            setReportData(state.data);
            const fromDate = state.formData.from_date;
            const toDate = state.formData.to_date;
            const formatFromDate = new Date(fromDate);
            const formatToDate = new Date(toDate);

            // Get the month and year
            const frommonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatFromDate);
            const fromyear = formatFromDate.getFullYear();
            const tomonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatToDate);
            const toyear = formatToDate.getFullYear();

            // Output the result
            const formattedDate = `${frommonth} ${fromyear} - ${tomonth} ${toyear}`;
            setReportingPeriod(formattedDate);

        }
    }, [state]);

    const goBack = () => {
        navigate(-1);
    };

    const handleClick = (formData) => {
        const { selectAll, ...rest } = formData;
        setLoading(true)
        create(rest, 'reports/internal/SaveInternalReport').then((res) => {
            if (res) {
                setLoading(false)
                const route = '/reports';
                navigate(route, { state: { data: res, formData: formData } });
            }
        });
    }

    if (loading) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 py-2">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                    </h1>
                </div>
            </main>
        );
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link onClick={goBack}>
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        Water Report {reportingperiod}

                    </h1>
                    <button className="btn-orange" onClick={() => handleClick(state.formData)} style={state && state.id ? { display: 'none' } : null}>
                        SAVE
                    </button>
                </div>
                <div>
                    <ul className="reportdetails">
                        <li key={3}>
                            <span>Reporting Period: </span>      <span>{reportingperiod}</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className='tabletitle'>TOTAL WATER CONSUMPTION ACROSS ALL FACILITIES</h4>
                    <table className="table supplier-details">
                        <thead>
                            <tr>
                                <th>Oprations</th>
                                <th>Sources</th>
                                <th>All Area (kiloliters)</th>
                                <th>All Areas in Stress (kiloliters)</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr className="table-light" key={1}>
                                <td>Water Withdrawal</td>
                                <td colspan="1"></td>
                                <td>2,300.00</td>
                                <td>00.00</td>
                            </tr>
                            <tr className="table-light" key={2}>
                                <td>Water Discharge</td>
                                <td colspan="1"></td>
                                <td>27,173.00</td>
                                <td>00.00</td>
                            </tr>
                            <tr className="table-light" key={3}>
                                <td>Water Consumtions</td>
                                <td colspan="1"></td>
                                <td>24,873.00</td>
                                <td>00.00</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div>
                    <h4 className='tabletitle'>DISAGGREGATIONS OF WATER CONSUMTIONS BY FACILITY</h4>
                    <table className="table supplier-details">
                        <thead>
                            <tr>
                                <th>Facility</th>
                                <th>Types</th>
                                <th>All Area</th>
                                <th>Water in kiloliters</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr className="table-light" key={1}>
                                <td>Head Office</td>
                                <td >Water Consumtions</td>
                                <td colspan="1"></td>
                                <td>24,873.00</td>
                            </tr>
                            <tr key={2}>
                                <td colspan="1"></td>
                                <td>Water Withdrawal</td>
                                <td>All Areas</td>
                                <td>27,173.00</td>

                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td>All Area with Water Stress</td>
                                <td>00.00</td>
                            </tr>
                            <tr key={3}>
                                <td colspan="1"></td>
                                <td>Water Discharge</td>
                                <td>All Area</td>
                                <td>23,00.00</td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td>All Area with Water Stress</td>
                                <td>00.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </main>
        </>
    );
}

export default ReportsWaterDataDetails